import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

/**
 * @deprecated values are coming from the v2 API
 * @param {int} areaId
 */
export default async function getRosterCustomFields(areaId = null) {
  try {
    const result = await mushodoPromise('GetRosterCustomFields', areaId);
    return {
      success: true,
      message: '',
      result,
    };
  } catch (e) {
    throw e;
  }
}
